export const APPROVED_SOFTWARE = {
  TITLE: 'Software Aprobado',
  SEARCH_PLACEHOLDER: 'Buscar software...',
  TABLE: {
    SOFTWARE_NAME: 'Nombre del Software',
    VENDOR: 'Proveedor',
    VERSION: 'Versión',
    PLATFORMS: 'Plataformas',
    ADDED_BY: 'Añadido Por',
  },
  DRAWER: {
    ADD_TITLE: 'Añadir Software',
    EDIT_TITLE: 'Editar Software',
    FIELDS: {
      SOFTWARE_NAME: 'Nombre del Software',
      VENDOR: 'Proveedor',
      VERSION: 'Versión',
      PLATFORMS: 'Plataformas',
      ADDED_BY: 'Añadido Por',
    },
    ALL_VERSIONS: 'Todas las versiones',
    ALL: 'Todas',
    SELECT_GROUP: 'Seleccionar un grupo',
    SEARCH_VENDOR: 'Buscar proveedores...',
    LOADING: 'Cargando...',
    NO_VENDOR_FOUND: 'No se encontró proveedor',
  },
  HIDE_UTILITIES: 'Ocultar utilidades',
  UTILITY: 'Utilidad',
  NO_SOFTWARE: 'Aún no hay software aprobado.',
  NO_RESULTS: 'Ningún software coincide con los filtros.',
  EXPORT_EMPTY: 'No hay software que exportar con los filtros actuales.',
  ACTIONS: {
    ADD_SOFTWARE: 'Añadir Software',
    EXPORT: 'Exportar CSV',
    SAVE_CHANGES: 'Guardar Cambios',
    CANCEL: 'Cancelar',
  },
  DELETE_DIALOG: {
    TITLE: 'Eliminar Software',
    DESCRIPTION_PREFIX: '¿Estás seguro de que deseas eliminar',
    DESCRIPTION_SUFFIX: '? Esta acción no se puede deshacer.',
    CONFIRM: 'Eliminar',
    CANCEL: 'Cancelar',
  },
  MESSAGES: {
    CREATE_SUCCESS: 'Software creado correctamente',
    UPDATE_SUCCESS: 'Software actualizado correctamente',
    DELETE_SUCCESS: 'Software eliminado correctamente',
  },
} as const
